module.exports = __webpack_public_path__ + "img/A.a958d7a4.png";